// =============================================================
// wallet.ts — 지갑 어댑터 파사드
//
//  MetaMask 전용. 내부 구현은 @wagmi/core (wagmi.ts).
//
//  ── 왜 @metamask/sdk 직접 사용을 그만뒀나 ─────────────────
//   · SDK.init() 이 window.ethereum 에 프록시를 주입해서,
//     진짜 확장이 없는 모바일 크롬에서도 injected 가 있는 것처럼 보였다.
//   · readonlyRPCMap 때문에 eth_chainId 가 즉답되어
//     "provider 살아있음" 오판 → SDK 의 정상 연결 핸드셰이크를 건너뜀.
//   · 증상: 모바일에서 MetaMask 앱이 열리기만 하고 승인 화면이 안 뜸.
//
//  wagmi 의 metaMask() 커넥터는 SDK 라이프사이클을 검증된 순서로 관리한다.
//  사내 DEXignation 프로젝트에서 동일 구성으로 모바일이 안정 동작 중.
//
//  ⚠ 카카오톡/텔레그램 등 인앱 웹뷰는 어떤 SDK 로도 지갑앱 호출이 막힘.
//    → inapp.ts 로 외부 브라우저 탈출을 병행 (main.ts).
// =============================================================

import { WagmiWalletAdapter } from './wagmi';
import type { WalletAdapter } from './types';

/** MetaMask 지갑 어댑터를 만든다. */
export function createWalletAdapter(): WalletAdapter {
  return new WagmiWalletAdapter();
}

export type { WalletAdapter, WalletSnapshot } from './types';
export { SdkError } from './types';